import { connect } from 'react-redux'
import { map } from 'lodash'

import { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'

import {
  filterPostsByTopicSlug,
  getBuildRegistryPosts,
  getNewPosts,
} from '../lib'
import PostCardRow from '../components/post-card-row'
import HeroPost from '../components/hero-post'
import TopicSection from '../components/topic-section'
import SideNav from 'components/side-nav'

import * as css from './landing-page.scss'

import { FEATURED_POSTS_COLLECTION_SLUG } from '../constants'

import { maybeFetchPosts } from '../actions'
import { SectionHeading } from '../../components/headings'

class LandingPage extends Component {
  componentDidMount() {
    // lazy load featured posts
    this.props.maybeFetchPosts(map(this.props.featuredPosts, 'id'))

    // lazy load new posts if user is still on the page
    setTimeout(
      () => this.props.maybeFetchPosts(map(this.props.newPosts, 'id')),
      5000
    )

    // lazy loading of build registry posts
    setTimeout(
      () =>
        this.props.maybeFetchPosts(map(this.props.buildRegistryPosts, 'id')),
      10000
    )
  }

  render() {
    const {
      buildRegistryPosts,
      featuredPosts,
      newPosts,
      posts,
      topicNavigation,
    } = this.props

    let navCategory = { title: 'Home', path: '/hello-baby', urlSlug: null }
    let sideNavTree = []
    map(topicNavigation.items, (topic) => {
      let tempArray = []
      map(topic.children, (topic) => {
        tempArray.push({
          title: topic.name,
          urlSlug: topic.slug,
          path: blUrls.helloBabyPostPath(topic.slug),
        })
      })
      sideNavTree.push({
        title: topic.name,
        urlSlug: topic.slug,
        children: tempArray,
        path: blUrls.helloBabyPostPath(topic.slug),
      })
    })

    return (
      <div className="container mtm pts ptn-sm mtxl-sm">
        <div className="visible-xs">
          <SectionHeading className="h3 mvm">Featured Guides</SectionHeading>
          <hr className="mtm mbl" />
        </div>
        <HeroPost post={featuredPosts[0]} />
        <PostCardRow
          posts={featuredPosts.slice(1, 5)}
          showTopics={true}
          className="mtxl"
          colClassName="col-md-3"
        />

        <Row className="mvl">
          <Col sm={3} className={classNames(css.sideNavContainer, 'hidden-xs')}>
            <SideNav
              sidebarTitle={'Guides'}
              navCategory={navCategory}
              categoryTree={sideNavTree !== 'undefined' ? sideNavTree : []}
            />
          </Col>
          <Col sm={9} className="mtl">
            <div className={css.landingContainer}>
              {typeof topicNavigation.items !== 'undefined' &&
                topicNavigation.items
                  .map((topic) => {
                    const topicPosts = filterPostsByTopicSlug(
                      posts,
                      topic.slug
                    ).slice(0, 5)
                    if (topicPosts && topicPosts.length) {
                      return (
                        <TopicSection
                          hideLastPostSm
                          key={'topic_section_' + topic.slug}
                          posts={topicPosts}
                          showTopics={false}
                          topic={{ name: topic.name, slug: topic.slug }}
                        />
                      )
                    } else {
                      return null
                    }
                  })
                  .filter((topicSection) => topicSection)}
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

LandingPage.propTypes = {
  buildRegistryPosts: PropTypes.array.isRequired,
  featuredPosts: PropTypes.array.isRequired,
  newPosts: PropTypes.array.isRequired,
  maybeFetchPosts: PropTypes.func.isRequired,
  topicNavigation: PropTypes.object,
}

const mapStateToProps = (state, ownProps) => ({
  featuredPosts: map(
    state.collections[FEATURED_POSTS_COLLECTION_SLUG].itemIds.slice(0, 5),
    (id) => state.posts[id]
  ), // take the first four posts
  newPosts: getNewPosts(state.posts),
  buildRegistryPosts: getBuildRegistryPosts(state.posts),
  posts: state.posts,
})

const ConnectedLandingPage = connect(mapStateToProps, {
  maybeFetchPosts,
})(LandingPage)

export default ConnectedLandingPage
